import { queryClient } from '../react-query/queryClient';
import { usersUrls } from '../constants/urls';
import axiosInstance, { lock } from './axiosInstance';

const getLocalStorageToken = () => localStorage.getItem('token');

const logoutHandler = () => {
  if (localStorage.getItem('fireBaseToken')) {
    axiosInstance.delete(
      usersUrls.deleteNotificationToken(localStorage.getItem('fireBaseToken'))
    );
  }

  lock.disable();
  queryClient.clear();
  queryClient.removeQueries();
  localStorage.clear();
  sessionStorage.clear();
  window.location.replace('/authentication/login');
  window?.ReactNativeWebView?.postMessage('logout');
};

export { getLocalStorageToken, logoutHandler };
